module.exports = __webpack_public_path__ + "static/media/IQ.2121768d.png";